import { defaultLocale, type Locale } from "./config";

// Prefix an internal href with the active locale (/az/...). tr (default) stays
// unprefixed; external/anchor/already-prefixed hrefs pass through unchanged.
// This is the option-1 substitute for next-intl's routing-aware <Link>.
export function localizeHref(href: string, locale: Locale): string {
    if (locale === defaultLocale) return href;
    if (!href.startsWith("/")) return href;
    if (href === "/") return `/${locale}`;
    if (href === `/${locale}` || href.startsWith(`/${locale}/`)) return href;
    return `/${locale}${href}`;
}
